module.exports = __webpack_public_path__ + "static/media/quiz_12b.1df2c4b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/quiz_12b.jpg
// module id = 690
// module chunks = 0